import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getRoute, getSession, loading, resubmitApplication } from '../../../actions/sessions';
import { asyncActions } from '../../../actions/general';
import useRouteStatus from '../../../hooks/useRouteStatus';
import Loading from '../../shared/Loading';
import Error from '../../shared/Error';

export default function RerunCredit({location}) {
  const dispatch = useDispatch();

  const isLoading = useSelector(state => state.sessions.get('loading'));
  const session = useSelector(state => state.sessions.get('session'));

  useRouteStatus(location);

  useEffect(() => {
    dispatch(loading(true));
    dispatch(asyncActions(
      resubmitApplication(session),
      getSession(),
      getRoute()
    ))
    .then(res => dispatch(loading(false)));
  }, []);

  return (
    <div id="content">
      <Error />
      <Loading active={isLoading} css="process-app-loader is-size-1 mt-5 mb-5" />
    </div>
  )
}
